import PropTypes from "prop-types"
import { Paper } from "@mui/material"
import { formatLongDate } from "helpers/formatters/dates"
import { percentageFormatter } from "helpers/formatters/numbers"
import Factor from "./factor"
import "./style.scss"

function HighestLowestAttribution({ date, attribution, maxFactors, openFactorProfile, highestTitle, lowestTitle, noPercent }) {
  return <Paper className="components_highest-lowest-attribution">
    <h2 className="header">{attribution.category} as of <span className="attribution-date">{formatLongDate(date)}</span></h2>
    <div className="charts-wrapper">
      <div className="chart highest">
        {highestTitle
          && <div className="chart-title-wrapper">
            <h4 className="chart-title">{highestTitle}</h4>
            <span className="chart-total">{percentageFormatter(attribution.totalPositive)}</span>
          </div>}
        {attribution.factors.positive.map((factor, i) => <Factor key={i} factor={factor} max={maxFactors} noPercent={noPercent} otherLabel="All Other Winning Factors" openFactorProfile={openFactorProfile} />)}
      </div>
      <div className="chart lowest">
        {lowestTitle
          && <div className="chart-title-wrapper">
            <h4 className="chart-title">{lowestTitle}</h4>
            <span className="chart-total">{percentageFormatter(attribution.totalNegative)}</span>
          </div>}
        {attribution.factors.negative.map((factor, i) => <Factor key={i} factor={factor} max={maxFactors} noPercent={noPercent} otherLabel="All Other Losing Factors" openFactorProfile={openFactorProfile} />)}
      </div>
    </div>
  </Paper>
}

HighestLowestAttribution.propTypes = {
  date: PropTypes.string.isRequired,
  attribution: PropTypes.object.isRequired,
  openFactorProfile: PropTypes.func,
  maxFactors: PropTypes.number.isRequired,
  noPercent: PropTypes.bool,
  lowestTitle: PropTypes.string,
  highestTitle: PropTypes.string,
}

export default HighestLowestAttribution
